import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  setContactInfo,
  schedulePriceQuote,
  scheduleBook,
  setSelectedPaymentMethodId,
  setSelectedRewardsAccountReferenceId,
  setPriceQuote,
  fetchApplicableTravelWalletItems,
  setTripPurpose,
  setTripDescription,
  fetchProductToEarn,
  updateUserPassenger,
  setPendingLoyaltySync,
} from "../../../actions/actions";
import { IStoreState } from "../../../../../reducers/types";
import { CorpDesktopCarBookWorkflow } from "./component";
import { getCarShopSelectedVehicle } from "../../../../shop/reducer";
import {
  getSelectedDriverAge,
  getIsBookingValid,
  getConfirmationDetails,
  isTravelerStepComplete,
  isContactStepComplete,
  getPriceDifferenceAcknowledged,
  areAllStepsCompletedInCheckout,
  getConfirmationEmail,
  getConfirmationPhoneNumber,
  getPriceQuote,
  getCombinedBookingSteps,
  getPriceQuoteErrors,
  getCardPaymentAccount,
  getIsHertzProvider,
  getHertzLoyaltyRewardsNumber,
  getConfirmationDetailsError,
  getSelectedDriver,
  getPaymentRequestV2,
  getCarAvailabilityRequest,
  getUseV1PurchaseFlow,
  getIsTravelWalletPaymentOnly,
  getUserSelectedTravelerId,
  getIsMissingLicense,
  getFlightInfoFieldSpec,
  getIsFlightInfoValid,
} from "../../../reducer";
import { ICorpCarAvailabilityLineItem } from "../../../../availability/reducer/utils/carAvailabilityHelperFunctions";
import {
  fetchTravelWalletCreditHistory,
  fetchTravelWalletDetails,
} from "../../../../travel-wallet/actions/actions";
import {
  getRewardsAccountForBanner,
  getEarnForHighestEarnRewardsAccount,
} from "../../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  driverAge: getSelectedDriverAge(state),
  selectedVehicle: getCarShopSelectedVehicle(
    state
  ) as ICorpCarAvailabilityLineItem | null,
  combinedBookingSteps: getCombinedBookingSteps(state),
  isBookingValid: getIsBookingValid(state),
  isTravelerStepComplete: isTravelerStepComplete(state),
  isContactStepComplete: isContactStepComplete(state),
  confirmation: getConfirmationDetails(state),
  priceDifferenceAcknowledged: getPriceDifferenceAcknowledged(state),
  allStepsCompleted: areAllStepsCompletedInCheckout(state),
  email: getConfirmationEmail(state),
  phoneNumber: getConfirmationPhoneNumber(state),
  priceQuote: getPriceQuote(state),
  priceQuoteErrors: getPriceQuoteErrors(state),
  cardPaymentAccount: getCardPaymentAccount(state),
  isHertzProvider: getIsHertzProvider(state),
  hertzLoyaltyRewardsNumber: getHertzLoyaltyRewardsNumber(state),
  confirmationDetailsErrors: getConfirmationDetailsError(state),
  driver: getSelectedDriver(state),
  paymentInfo: getPaymentRequestV2(state),
  carAvailabilityRequest: getCarAvailabilityRequest(state),
  useV1PurchaseFlow: getUseV1PurchaseFlow(state),
  isTravelWalletPaymentOnly: getIsTravelWalletPaymentOnly(state),
  largestValueAccount: getRewardsAccountForBanner(state),
  calculatedEarn: getEarnForHighestEarnRewardsAccount(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  isMissingLicense: getIsMissingLicense(state),
  hasFlightInfoField: getFlightInfoFieldSpec(state) != null,
  isFlightInfoValid: getIsFlightInfoValid(state),
});

const mapDispatchToProps = {
  setContactInfo,
  schedulePriceQuote,
  scheduleBook,
  setSelectedPaymentMethodId,
  setSelectedRewardsAccountReferenceId,
  fetchTravelWalletDetails,
  setPriceQuote,
  fetchApplicableTravelWalletItems,
  fetchTravelWalletCreditHistory,
  setTripPurpose,
  setTripDescription,
  fetchProductToEarn,
  updateUserPassenger,
  setPendingLoyaltySync,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type DesktopCarBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedDesktopCarBookWorkflow = withRouter(
  connector(CorpDesktopCarBookWorkflow)
);
